export class CompanyConfigModel {
        CompanyId: string;
        CompanyName: string;
        Email: string;
        Phone: string;
        TaxCode: number;
        BankAccountId: string;
        CompanyAddress: string;
        ContactName: string;
        ContactRole: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/companyConfig.model.ts